<template>
  <div v-if="access.Act_List" class="kstmod-debt-relatedlist">
    <Rows
      :access="access"
      :items="items"
      :vendor="vendor"
    />
  </div>
</template>

<script>
import Model from "../DebtModel.js";

import Rows from "./DebtRL_Rows.vue";

export default {
  components: {
    Rows
  },
  props: {
    items: Array,
    // field visibility (order by appearance)
    vendor: Boolean
  },
  data: () => ({
    access: {}
  }),
  created() {
    this.init();
  },
  methods: {
    init() {
      this.access = this.$kst.Access.create(Model.Access);
    }
  }
}
</script>